import React from "react";
import ProductOverviewSkeleton from "./Overview/ProductOverviewSkeleton";
import ImageSkeleton from "theme/components/atoms/Image/ImageSkeleton";

const ProductItemSkeleton = () => {
  return (
    <div className="product-item">
      <div className="product-item__image">
        <ImageSkeleton format="small" appearance="full" />
      </div>
      <div className="product-item__overview">
        <ProductOverviewSkeleton />
      </div>
    </div>
  );
};

export default ProductItemSkeleton;
